export const CAROUSEL = {
  168: "?$n_240w$&wid=168&fit=constrain",
  317: "?$n_320w$&wid=317&fit=constrain",
  476: "?$n_480w$&wid=476&fit=constrain",
  513: "?$n_640w$&wid=513&fit=constrain",
  750: "?$n_750w$&wid=750&fit=constrain",
};
export const HERO = {
  317: "?$n_320w$&wid=317&fit=constrain",
  476: "?$n_480w$&wid=476&fit=constrain",
  513: "?$n_640w$&wid=513&fit=constrain",
  750: "?$n_750w$&wid=750&fit=constrain",
  952: "?$n_960w$&wid=952&fit=constrain",
  1125: "?$n_1280w$&wid=1125&fit=constrain",
  1926: "?$n_1920w$&wid=1926&fit=constrain",
};
export const THUMBNAIL = {
  40: "?$n_240w$&wid=40&fit=constrain",
  56: "?$n_240w$&wid=56&fit=constrain",
  75: "?$n_240w$&wid=75&fit=constrain",
  120: "?$n_240w$&wid=120&fit=constrain",
  240: "?$n_240w$&wid=168&fit=constrain",
  317: "?$n_320w$&wid=317&fit=constrain",
};
export const COLLAGE = {
  240: "?$n_240w$&wid=240&fit=constrain",
  320: "?$n_320w$&wid=320&fit=constrain",
  480: "?$n_480w$&wid=480&fit=constrain",
  640: "?$n_640w$&wid=640&fit=constrain",
  750: "?$n_750w$&wid=750&fit=constrain",
  960: "?$n_960w$&wid=960&fit=constrain",
  1280: "?$n_1280w$&wid=1280&fit=constrain",
  1920: "?$n_1920w$&wid=1920&fit=constrain",
};
export const CARD = {
  163: "?$n_240w$&wid=163&fit=constrain",
  218: "?$n_240w$&wid=218&fit=constrain",
  326: "?$n_480w$&wid=326&fit=constrain",
  436: "?$n_480w$&wid=436&fit=constrain",
  489: "?$n_640w$&wid=489&fit=constrain",
  654: "?$n_750w$&wid=654&fit=constrain",
};

export const CAROUSEL_IMAGE_SIZE = 168;
export const PRODUCT_LIMIT = 72;
export const TRENDING_CATEGORY_ID_TOPSHOP = 52847;
export const TRENDING_CATEGORY_ID_TOPMAN = 52849;
export const TIKTOK_URL = "https://www.tiktok.com/@topshoptopman";
export const PINTEREST_URL = "https://www.pinterest.com/topshop";
export const TOPSHOP_INSTAGRAM_URL = "https://www.instagram.com/topshop";
export const TOPMAN_INSTAGRAM_URL = "https://www.instagram.com/topman";
export const CORPORATE_RESPONSIBILITY_URL =
  "https://www.asosplc.com/fashion-with-integrity/";
export const CTA_REF_KEY = "ctaref";
export const AFFILIATE_ID_KEYS = ["affid", "xaffid"];

export const EU_STORE_CONFIG = [
  { code: "AT", path: "" },
  { code: "BE", path: "" },
  { code: "BG", path: "" },
  { code: "HR", path: "" },
  { code: "CY", path: "" },
  { code: "CZ", path: "" },
  { code: "EE", path: "" },
  { code: "FI", path: "" },
  { code: "FR", path: "fr-FR" },
  { code: "DE", path: "de-DE" },
  { code: "GR", path: "" },
  { code: "HU", path: "" },
  { code: "IT", path: "" },
  { code: "LV", path: "" },
  { code: "LT", path: "" },
  { code: "LU", path: "" },
  { code: "MT", path: "" },
  { code: "NL", path: "" },
  { code: "PT", path: "" },
  { code: "RO", path: "" },
  { code: "SK", path: "" },
  { code: "SI", path: "" },
  { code: "ES", path: "" },
  { code: "IE", path: "" },
] as const;

export const BRAND_FIT_INDICATORS = [
  "Petite",
  "Hourglass",
  "Tall",
  "Maternity",
  "Plus",
] as const;

export const EU_TOPSHOP_BASE_URL = "https://eu.topshop.com";
export const ASOS_BASE_URL = "https://www.asos.com";
export const GEO_REDIRECT_DISMISSED_KEY = "geoRedirectDismissed";
export const LEGACY_NON_UK_NOTIFICATION_COOKIE = "nonUkNotificationDismissed";
export const GB_TOPSHOP_BASE_URL = "https://www.topshop.com/gb";
